import React from 'react'
import classNames from 'classnames'

export const Container = (props) => {
  const classes = classNames('view-content',
    props.classes
  )

  return (<div className={classes}>
    {props.children}
  </div>)
}
